module.exports = __webpack_public_path__ + "img/20191010170702269.a2fcb48e.jpg";